'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { NavigationItem } from './NavigationItem';
import { ButtonWrapper, Icon, Navigation, NavigationToggle, Overlay, Root, Section, Title } from './SecondaryNavigation.styles';
export const SecondaryNavigation = ({ children, isButtonIntroOnDesktop = false, secondaryNavigation, title })=>{
    const [isOpen, setIsOpen] = useState(false);
    const [isButtonVisible, setIsButtonVisible] = useState(false);
    const navigation = useRef(null);
    useEffect(()=>{
        const observer = new IntersectionObserver((entries)=>entries.forEach((entry)=>{
                setIsButtonVisible(!entry.isIntersecting);
            }));
        const sibling = navigation.current?.nextElementSibling;
        if (sibling) {
            observer.observe(sibling);
            return ()=>observer.unobserve(sibling);
        }
    }, []);
    return /*#__PURE__*/ _jsx(Root, {
        "data-testid": "secondary-navigation",
        ref: navigation,
        children: /*#__PURE__*/ _jsxs(Section, {
            children: [
                /*#__PURE__*/ _jsx(Title, {
                    size: "M",
                    children: title
                }),
                Boolean(secondaryNavigation?.length) && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(NavigationToggle, {
                            onClick: ()=>setIsOpen(!isOpen),
                            children: /*#__PURE__*/ _jsx(Icon, {
                                $isToggled: isOpen
                            })
                        }),
                        /*#__PURE__*/ _jsx(Navigation, {
                            $isOpen: isOpen,
                            children: secondaryNavigation.map((item)=>/*#__PURE__*/ _jsx(NavigationItem, {
                                    ...item
                                }, item.href))
                        }),
                        /*#__PURE__*/ _jsx(Overlay, {
                            $isVisible: isOpen,
                            onClick: ()=>setIsOpen(false)
                        })
                    ]
                }),
                Boolean(children) && /*#__PURE__*/ _jsx(ButtonWrapper, {
                    $isButtonIntroOnDesktop: isButtonIntroOnDesktop,
                    $isVisible: isButtonVisible,
                    children: children
                })
            ]
        })
    });
};

//# sourceMappingURL=SecondaryNavigation.js.map